import { getPartnerDetails } from '../utils/helper'

export const getConfigDetails = () => {

  //Get the partner
  // const user = window.location.toString().split('/')[3]

  // switch ('demo') {
  // switch ('preStage') {
  // switch ('staging') {
  // switch ('preProd') {
  //  switch ('mob') {
    switch ('live') {
    // switch ('curl') {
    case 'demo': //staging2
      return {
        baseURL: 'https://demo-api.parkengage.com/',
        partnerUrl: 'https://demo-admin.parkengage.com',
        transientURL: 'https://demo-transient.parkengage.com',
        ticketURL: 'https://demo-getreceipt.parkengage.com',
        portalURL: 'https://demo-customerportal.parkengage.com',
        googlePayScript: 'https://wallet-cert.dcap.com/v1/client/googlepay',
				payButtonScript: 'https://pay.google.com/gp/p/js/pay.js',
				applePayScript: 'https://wallet-cert.dcap.com/v1/client/applepay',
        applePayDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-2.0.0.js',
				googlePayDTScript: null,
				payButtonDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/payment-button-2.0.0.js',
        applePayHLScript: 'https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js',
				googlePayHLScript: null,
				payButtonHLScript: null,
        FACILITY_ID: 1,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
    case 'preStage': //staging
      return {
        baseURL: 'https://pre-stage-api.parkengage.com/',
        // partnerUrl: 'https://pre-stage-admin.parkengage.com',
        transientURL: 'https://pre-stage-transient.parkengage.com',
        ticketURL: 'https://pre-stage-getreceipt.parkengage.com',
        partnerUrl: 'https://pre-stage-admin.parkengage.com',
        portalURL: 'https://pre-stage-customerportal.parkengage.com',
        googlePayScript: 'https://wallet-cert.dcap.com/v1/client/googlepay',
				payButtonScript: 'https://pay.google.com/gp/p/js/pay.js',
				applePayScript: 'https://wallet-cert.dcap.com/v1/client/applepay',
        applePayDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-2.0.0.js',
				googlePayDTScript: null,
				payButtonDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/payment-button-2.0.0.js',
        applePayHLScript: 'https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js',
				googlePayHLScript: null,
				payButtonHLScript: null,
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
    case 'staging': //staging
      return {
        baseURL: 'https://staging-api.parkengage.com/',
        adminUrl: 'https://staging-admin.parkengage.com',
        transientURL: 'https://staging-transient.parkengage.com',
        ticketURL: 'https://staging-getreceipt.parkengage.com',
        portalURL: 'https://staging-customerportal.parkengage.com',
        portalURLPCI: 'https://staging-customerportal.breezeparking.com',
        partnerUrl: 'https://staging-admin.parkengage.com',

        // Rev-Pass URLs
        revadminUrl: 'https://staging-backoffice.rev-pass.com',
        revtransientURL: 'https://staging-transient.rev-pass.com',
        revticketURL: 'https://staging-getreceipt.rev-pass.com',
        revportalURL: 'https://staging-customerportal.rev-pass.com',
        revpartnerUrl: 'https://staging-backoffice.rev-pass.com',

        googlePayScript: 'https://wallet-cert.dcap.com/v1/client/googlepay',
				payButtonScript: 'https://pay.google.com/gp/p/js/pay.js',
				applePayScript: 'https://wallet-cert.dcap.com/v1/client/applepay',
        applePayDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-2.0.0.js',
				googlePayDTScript: null,
				payButtonDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/payment-button-2.0.0.js',
        applePayHLScript: 'https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js',
				googlePayHLScript: null,
				payButtonHLScript: null,
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '356560',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'vikrant-tyagi356560',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
    case 'preProd': //staging
      return {
        baseURL: 'https://preprod-api.parkengage.com/',
        transientURL: 'https://preprod-transient.parkengage.com',
        ticketURL: 'https://preprod-getreceipt.parkengage.com',
        partnerUrl: 'https://preprod-admin.parkengage.com',
        portalURL: 'https://preprod-customerportal.parkengage.com',
        portalURLPCI: 'https://preprod-customerportal.breezeparking.com',

        // Rev-Pass URLs
        revadminUrl: 'https://preprod-backoffice.rev-pass.com',
        revtransientURL: 'https://preprod-transient.rev-pass.com',
        revticketURL: 'https://preprod-getreceipt.rev-pass.com',
        revportalURL: 'https://preprod-customerportal.rev-pass.com',
        revpartnerUrl: 'https://preprod-backoffice.rev-pass.com',

        googlePayScript: 'https://wallet.dcap.com/v1/client/googlepay',
				payButtonScript: 'https://pay.google.com/gp/p/js/pay.js',
				applePayScript: 'https://wallet.dcap.com/v1/client/applepay',
        applePayDTScript: 'https://pay.datatrans.com/upp/payment/js/datatrans-2.0.0.js',
				googlePayDTScript: null,
				payButtonDTScript: 'https://pay.datatrans.com/upp/payment/js/payment-button-2.0.0.js',
        applePayHLScript: 'https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js',
				googlePayHLScript: null,
				payButtonHLScript: null,
        FACILITY_ID: 195,
        FULL_SEASON: '502',
        HALF_SEASON: '506',
        SIX_PACK: '507',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
      case 'live': //live
      return {
        baseURL: 'https://api.parkengage.com/',
        adminUrl: 'https://partner.parkengage.com',
        transientURL: 'https://transient.parkengage.com',
        ticketURL: 'https://getreceipt.parkengage.com',
        portalURL: 'https://customerportal.parkengage.com',
        portalURLPCI: 'https://customerportal.breezeparking.com',
        partnerUrl: 'https://partner.parkengage.com',

        // Rev-Pass URLs
        revadminUrl: 'https://backoffice.rev-pass.com',
        revtransientURL: 'https://transient.rev-pass.com',
        revticketURL: 'https://getreceipt.rev-pass.com',
        revportalURL: 'https://customerportal.rev-pass.com',
        revpartnerUrl: 'https://backoffice.rev-pass.com',

        googlePayScript: 'https://wallet.dcap.com/v1/client/googlepay',
				payButtonScript: 'https://pay.google.com/gp/p/js/pay.js',
				applePayScript: 'https://wallet.dcap.com/v1/client/applepay',
        applePayDTScript: 'https://pay.datatrans.com/upp/payment/js/datatrans-2.0.0.js',
				googlePayDTScript: null,
				payButtonDTScript: 'https://pay.datatrans.com/upp/payment/js/payment-button-2.0.0.js',
        // applePayHLScript: 'https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js',
        applePayHLScript: 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js',
				googlePayHLScript: null,
				payButtonHLScript: null,

        FACILITY_ID: 32,
        FULL_SEASON: '80',
        HALF_SEASON: '81',
        SIX_PACK: '82',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
    case 'curl': //curl
      return {
        baseURL: 'https://api-mob.parkengage.com/',
        adminUrl: 'https://partner-mob.parkengage.com',
        transientURL: 'https://transient-mob.parkengage.com',
        ticketURL: 'https://getreceipt-mob.parkengage.com',
        portalURL: 'https://customerportal-mob.parkengage.com',
        portalURLPCI: 'https://customerportal-mob.parkengage.com',
        partnerUrl: 'https://partner-mob.parkengage.com',
        googlePayScript: 'https://wallet-cert.dcap.com/v1/client/googlepay',
				payButtonScript: 'https://pay.google.com/gp/p/js/pay.js',
				applePayScript: 'https://wallet-cert.dcap.com/v1/client/applepay',
        applePayDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-2.0.0.js',
				googlePayDTScript: null,
				payButtonDTScript: 'https://pay.sandbox.datatrans.com/upp/payment/js/payment-button-2.0.0.js',
        applePayHLScript: 'https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js',
				googlePayHLScript: null,
				payButtonHLScript: null,
        FACILITY_ID: 32,
        FULL_SEASON: '80',
        HALF_SEASON: '81',
        SIX_PACK: '82',
        PARTNER_ID: getPartnerDetails()?.clients?.partner_id ? getPartnerDetails()?.clients?.partner_id : '3307',
        CLIENT_ID: getPartnerDetails()?.clients?.id ? getPartnerDetails()?.clients?.id : 'parking-payments3307',
        CLIENT_SECRET: getPartnerDetails()?.clients?.secret ? getPartnerDetails()?.clients?.secret : '',
      }
  }
}
